/*eslint-disable*/
import { Box, Button, TextField, InputLabel } from "@mui/material";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import React from "react";
import PlayerListDialog from "./PlayerListDialog";
import { useEffect } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AddNewAchievement,
  GetPlayers,
} from "../../../../api/AuthenticationServices";
const imageConvert = require("../../../imageConvert");

const NewAchievement = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const [file, setFile] = useState(null);

  const handleFileChange = async (event) => {
    const base64 = await imageConvert(event.target.files[0]);
    setFile(base64);
  };

  //Select Players
  const [records, setRecords] = useState([]);
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
    },
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    console.log(config);
    try {
      const res = await GetPlayers(config);
      if (res.data.status === "success") {
        setRecords(res.data.data);
        console.log("Records ", res.data.data);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }
  const [isPlayerListDialogOpen, setIsPlayerListDialogOpen] = useState(false);
  const [selectedPlayers, setSelectedPlayers] = useState([]);

  const handlePlayerListButtonClick = () => {
    setIsPlayerListDialogOpen(true);
  };

  const handlePlayerListDialogClose = () => {
    setIsPlayerListDialogOpen(false);
  };

  const handleSelectedPlayersChange = (newSelectedPlayers) => {
    setSelectedPlayers(newSelectedPlayers);
    setIsPlayerListDialogOpen(false);
  };
  console.log(selectedPlayers);

  //Radio
  const [acMatchResult, setSelectedResultValue] = useState("");

  const handleRadioChange = (event) => {
    setSelectedResultValue(event.target.value);
  };

  //Sending data
  const sendData = async (e, values) => {
    // console.log("Form Submit Values", values);

    console.log(values);
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("title", values.acTitle);
      formData.append("place", values.acPlace);
      formData.append("date", values.acDate);
      formData.append("description", values.acDescription);
      formData.append("opponent", values.acOpponent);
      formData.append("goalsScored", values.acGoalsScored);
      formData.append("goalsConceded", values.acGoalsConceded);
      formData.append("gameResult", acMatchResult);
      formData.append("players", selectedPlayers);

      const fileConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
        },
      };
      const res = await AddNewAchievement(formData, fileConfig);
      //   console.log("File Response : ", fileRes);
      //   alert("File uploaded successfully!");

      // const res = await AddNewCoach(formData, config);

      if (res.data.status === "success") {
        // console.log("Inside Successs");
        alert(res.data.message);
        navigate("/admin/viewachievements");
      }
    } catch (e) {
      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header title="NEW ACHIEVEMENT" subtitle="Create a New Achievement" />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            // console.log(values,handleChange)
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Title"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acTitle}
                  name="acTitle"
                  error={!!touched.acTitle && !!errors.acTitle}
                  helperText={touched.acTitle && errors.acTitle}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="Date of Achievement"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acDate}
                  name="acDate"
                  error={!!touched.acDate && !!errors.acDate}
                  helperText={touched.acDate && errors.acDate}
                  sx={{ gridColumn: "span 4" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Place"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acPlace}
                  name="acPlace"
                  error={!!touched.acPlace && !!errors.acPlace}
                  helperText={touched.acPlace && errors.acPlace}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Opponent"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acOpponent}
                  name="acOpponent"
                  error={!!touched.acOpponent && !!errors.acOpponent}
                  helperText={touched.acOpponent && errors.acOpponent}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Goals Scored"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acGoalsScored}
                  name="acGoalsScored"
                  error={!!touched.acGoalsScored && !!errors.acGoalsScored}
                  helperText={touched.acGoalsScored && errors.acGoalsScored}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Goals Conceded"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acGoalsConceded}
                  name="acGoalsConceded"
                  error={!!touched.acGoalsConceded && !!errors.acGoalsConceded}
                  helperText={touched.acGoalsConceded && errors.acGoalsConceded}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Description"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acDescription}
                  name="acDescription"
                  error={!!touched.acDescription && !!errors.acDescription}
                  helperText={touched.acDescription && errors.acDescription}
                  sx={{ gridColumn: "span 4" }}
                />
                <InputLabel id="pl-gen" sx={{ gridColumn: "span 4" }}>
                  Game Result
                </InputLabel>
                {/* <FormControl component="fieldset"> */}
                <RadioGroup value={acMatchResult} onChange={handleRadioChange}>
                  <FormControlLabel
                    value="Win"
                    control={<Radio />}
                    label="Win"
                  />
                  <FormControlLabel
                    value="Draw"
                    control={<Radio />}
                    label="Draw"
                  />
                  <FormControlLabel
                    value="Lost"
                    control={<Radio />}
                    label="Lost"
                  />
                </RadioGroup>
                {/* </FormControl> */}
                <InputLabel id="pl-gen" sx={{ gridColumn: "span 4" }}>
                  Upload Photo
                </InputLabel>
                <input type="file" onChange={handleFileChange} />
              </Box>
              <div>
                <Button
                  variant="contained"
                  onClick={handlePlayerListButtonClick}
                >
                  Select Players
                </Button>
                <PlayerListDialog
                  players={records}
                  selectedPlayers={selectedPlayers}
                  open={isPlayerListDialogOpen}
                  onClose={handlePlayerListDialogClose}
                  onSelectedPlayersChange={handleSelectedPlayersChange}
                />
              </div>
              {/* {selectedPlayers.length > 0 && (
                <div>
                  <h2>Selected Players:</h2>
                  <ul>
                    {selectedPlayers.map((record) => (
                      // <li key={records.id}>{records.name}</li>
                    ))}
                  </ul>
                </div>
              )} */}
              {/* <button type="submit">asdasd</button> */}

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  disabled={false}
                  color="secondary"
                  variant="contained"
                >
                  Create New Achievement
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  acTitle: yup.string().required("required"),
  acDate: yup.string().required("required"),
  acPlace: yup.string().required("required"),
  acOpponent: yup.string().required("required"),
  acDescription: yup.string().required("required"),
  acGoalsScored: yup.string().required("required"),
  acGoalsConceded: yup.string().required("required"),
});
const initialValues = {
  acTitle: "",
  acPlace: "",
  acDate: "",
  acOpponent: "",
  acDescription: "",
  acGoalsScored: "",
  acGoalsConceded: "",
};

export default NewAchievement;
